/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Not_Ready_For_SubmissionInputs */

const en_error_linesheet_not_ready_for_submission = /** @type {(inputs: Error_Linesheet_Not_Ready_For_SubmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The linesheet is missing data required for submission.`)
};

/**
* | output |
* | --- |
* | "The linesheet is missing data required for submission." |
*
* @param {Error_Linesheet_Not_Ready_For_SubmissionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_not_ready_for_submission = /** @type {((inputs?: Error_Linesheet_Not_Ready_For_SubmissionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Not_Ready_For_SubmissionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_not_ready_for_submission(inputs)
});